import React, {
  useState,
} from "react";
import {
  Button,
  Divider,
  Flex,
} from "antd";
import { toast } from "react-toastify";
import { getUser } from "../../../../../utils/helpers";

const DfLabelCard = ({
  item,
  cardIdx,
  markTestRunOnInstrument,
  labelCardsRef,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    labelCardsRef.current.loadings[cardIdx] = true;
    const { test_in_sample_id: id, dilution_factors_list, loaded_on_instruments } = item;
    const payload = {
      test_in_sample_details: [{ id, dilution_factors_list, loaded_on_instruments }],
      action: "load",
      user_id: getUser().id,
    };
    const { message, success } = await markTestRunOnInstrument(payload);
    if (success) {
      toast.success(message);
      setSubmitted(true);
      labelCardsRef.current.submitted++;
    } else {
      toast.error(message);
    }
    labelCardsRef.current.loadings[cardIdx] = false;
    setLoading(false);
  };

  return (
    <Flex vertical className="PendingTable__DfCard">
      <Flex justify="space-between" align="center">
        <span>{item.genista_id}</span>
        {!submitted && (<Button type="link" loading={loading} onClick={handleSubmit}>Submit</Button>)}
        {submitted && (<span className="PendingTable__DfCard__SubmittedText">Submitted</span>)}
      </Flex>
      <Divider className="PendingTable__DfDivider" />
      <ul>
        {item.labels.map((label, j) => <li key={j}>{label}</li>)}
      </ul>
    </Flex>
  );
};

export default DfLabelCard;
